export default __webpack_public_path__ + "./images/st.cb6cd907.png";